// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4241":"3f00dbf798d10d72","8497":"383258107a099825","9126":"d85ee3ec47be168c"}[chunkId] + ".js";
};